export default {
  title: 'Adgangskontrol: {{role}}',
  form: {
    companies: {
      label: 'Synlig for alle medlemmer med rollen {{role}}',
      tooltip: 'Dette tilføjes til de steder, hvor teammedlemmet har tilmeldt sig',
    },
  },
  buttons: {
    save: 'Gem',
  },
  toasts: {
    failed_to_load_data: 'Data kunne ikke indlæses, opdater siden',
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes',
    changes_got_saved: 'Ændringerne er gemt',
  },
};
